import { Roles } from "./constants/roles";
import { FormBase } from "./util/form-base-form";

export class AppForm extends FormBase {
    public getImageZoomRoots(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, "[data-image-zoom-root]", HTMLElement);
    }

    public getListingProductCards(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.PRODUCT_CARD}"]`, HTMLElement);
    }

    public getProductImageZoomToggles(root: ParentNode = document): HTMLInputElement[] {
        return this.queryElements(root, `[data-role="${Roles.PRODUCT_LIST_IMAGE_ZOOM_TOGGLE}"]`, HTMLInputElement);
    }

    public isInsideElementModalOverlay(element: Element | null | undefined): boolean {
        if (!(element instanceof Element)) return false;
        return this.getElementModalOverlays(document).some((overlay) => overlay.contains(element));
    }

    public isInsideElementModalBody(element: Element | null | undefined): boolean {
        if (!(element instanceof Element)) return false;
        return this.closest(element, `[data-role="${Roles.ELEMENT_MODAL_BODY}"]`) !== null;
    }

    public isInsideHiddenPostDetail(element: Element | null | undefined): boolean {
        if (!(element instanceof Element)) return false;

        return (
            this.closest(
                element,
                `[data-role="${Roles.POST_DETAIL}"][data-hidden-role="${Roles.POST_DETAIL_HIDDEN}"]`,
                HTMLElement,
            ) !== null
        );
    }

    public hasPostCard(root: ParentNode = document): boolean {
        return this.queryElement(root, `[data-role="${Roles.POST_CARD}"]`, HTMLElement) !== null;
    }

    private getElementModalOverlays(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.ELEMENT_MODAL_OVERLAY}"]`, HTMLElement);
    }
}

export const appForm = new AppForm();
